import axios from 'axios'

//const API_URL = 'http://localhost:3000'
const API_URL = 'https://api.deskontime.com/'

const securedAxiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
    'x-api-key': '1rZ2TFmScE4uEl9XcMh9n5x8x1pgEn1M4mDSsyPW'
  }
})

const plainAxiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
})

securedAxiosInstance.interceptors.request.use(config => {
  const method = config.method.toUpperCase()

  config.headers = {
    ...config.headers,
    'Authorization': 'Bearer ' + localStorage.csrf
  }
  return config
})

plainAxiosInstance.interceptors.request.use(config => {
  const method = config.method.toUpperCase()
  config.headers = {
    ...config.headers
  }
  return config
})

securedAxiosInstance.interceptors.response.use(null, error => {

  if (error.response && error.response.config && error.response.status === 401) {
  
    return plainAxiosInstance.post('/refresh', {}, { headers: { 'Authorization': 'Bearer ' + localStorage.csrf } })
      .then(response => {

        localStorage.csrf = response.data.csrf

        localStorage.signedIn = true
        let retryConfig = error.response.config
        retryConfig.headers['Authorization'] = 'Bearer ' + localStorage.csrf
        return plainAxiosInstance.request(retryConfig)
      }).catch(error => {
        
        localStorage.clear()
        
        location.replace('/')
        return Promise.reject(error)
      })
  } else {
    return Promise.reject(error)
  }
})

export { securedAxiosInstance, plainAxiosInstance}
